module.exports = __webpack_public_path__ + "media/images/thumbs/biology/v_qv_dna_double_helix_5-a6ae5bd60d89529e80fa7aa797a3da9d.jpg";